import { Injectable, signal } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { ToastModel } from '@app/shared/components/toasts/toasts.model';

@Injectable({
  providedIn: 'root'
})
export class ToastsService {
  toasts = signal<ToastModel[]>([]);

  showSuccess(text: string) {
    this.showToast(text, 'w-100 text-center bg-success text-white');
  }

  showError(text: string) {
    this.showToast(text, 'w-100 text-center bg-danger text-white');
  }

  removeToast(id: string) {
    const updatedToasts = this.toasts().filter((toast) => toast.id !== id);
    this.toasts.set(updatedToasts);
  }

  private showToast(text: string, toastClass: string) {
    const toast: ToastModel = { id: uuidv4(), text, class: toastClass };
    this.toasts.update((values) => [...values, toast]);
  }
}
